import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Captura global do beforeinstallprompt - ANTES do React montar
;(window as any).__pwaInstallPrompt = null
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault()
  ;(window as any).__pwaInstallPrompt = e
  console.log('🎯 beforeinstallprompt capturado globalmente!')
})

// Guard: não registrar SW em iframe ou preview do Lovable
const isInIframe = (() => {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
})()

const isPreviewHost =
  window.location.hostname.includes('id-preview--') ||
  window.location.hostname.includes('lovableproject.com')

if (isPreviewHost || isInIframe) {
  // Limpar SW existente em contexto de preview/iframe
  navigator.serviceWorker?.getRegistrations().then((registrations) => {
    registrations.forEach((r) => r.unregister())
  })
}
// Em produção, o registro de /sw.js é feito exclusivamente pelo bloco em index.html
// para evitar duplicação e loops de reload.

const rootElement = document.getElementById('root')!
ReactDOM.createRoot(rootElement).render(
  React.createElement(App)
)
